export default {
  colors: {
    primary: '#FF9F4F',
    primary600: '#FF7E12',
    secondary: '#1E96FC',
    secondary600: '#007DE8',
    defaultText: '#13293D',
    defaultWhite: '#ffffff',
    lightGrey: '#F7FBFD',
    disabled: '#bdbdbd',
    gray600: '#13293D',
    gray500: '#76889A',
    backgroundLight: '#DBEDFF',
    blue300: '#E9F2FC',
    blue500: '#C6DFF9',
    titleGradient:
      'linear-gradient(90deg, #DBEDFF 0.05%, rgba(255, 255, 255, 0.00) 99.93%);',
  },
  breakpoint: {
    desktop: '1024px',
    tablet: '768px',
    mobile: '480px',
    smallMobile: '380px',
  },
  constant: {
    containerWidth: '1200px',
    containerPaddingX: '16px',
    transition: '0.25s',
  },
};
